



























import { Component, Prop } from "vue-property-decorator";
import { Chart } from "chart.js";
import FetchStatsMixin from "@/components/app/global/stats/stat/_fetchStatsMixin";
import LineChart from "./_lineChart.vue";
import {
  defaultChartConfig,
  getMinMax
} from "@/components/app/global/stats/charts/utils";

const defaultLegendClickHandler = Chart.defaults.plugins.legend.onClick;

@Component({
  components: {
    "line-chart": LineChart
  }
})
export default class VueChart extends FetchStatsMixin {
  @Prop({ default: "line" })
  public type!: string;

  @Prop({ default: false })
  public simple!: boolean;

  @Prop({ default: "" })
  public title!: string;

  @Prop({ default: 320 })
  public height!: number;

  @Prop({ default: () => null })
  public config!: object;

  // Getters
  public get chartOptions() {
    const data = this.chartData;
    const config = defaultChartConfig({
      chartData: data,
      config: this.$_.merge(this.config, {
        legend: {
          display: !!this.currencyCode
        },
        plugins: {
          legend: {
            /**
             * Calculate new Y axis min and max excluding hidden datasets and update chart
             */
            onClick: async (event, legendItem, legend) => {
              // Do default logic
              defaultLegendClickHandler.apply(legend, [
                event,
                legendItem,
                legend
              ]);

              const index = legendItem.datasetIndex;
              const chart = legend.chart;
              data.datasets[index].isHidden = !chart.isDatasetVisible(index);

              const { minY, maxY, stepSize } = getMinMax({
                datasets: this.$_.filter(data.datasets, ds => !ds.isHidden),
                config
              });

              this.$_.set(config, "scales.y.suggestedMax", maxY);
              this.$_.set(config, "scales.y.suggestedMin", minY);
              this.$_.set(config, "scales.y.ticks.stepSize", stepSize);

              chart.update();
            }
          }
        }
      }),
      simple: this.simple
    });

    return config;
  }

  public get chartDataLoading() {
    const data = this.getStatValue(this.currencyCode);
    // Show grey chart when loading
    const datasets = this.$_.get(data, "datasets", []);
    const loadingDatasets = this.$_.map(datasets, i => ({
      label: i.label,
      backgroundColor: "#5959599c",
      borderColor: "#5959599c",
      data: []
    }));

    return {
      datasets: loadingDatasets,
      labels: data?.labels
    };
  }

  public get chartData() {
    if (this.isLoading || !this.statResult) return this.chartDataLoading;
    return this.statResult;
  }
}
